import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTButton from "../../_common/_buttons/Button"
import FatChevron from "../../_common/_icons/FatChevron"
import MCLoading from "../Loading"


const ButtonWithChevron = (props) => {

    const {
        loading
    } = props

    return (
        <NRTButton {...props}
                   disabled={props.disabled || loading}
                   className={'nrt-button-with-chevron'}>


            {
                loading && (
                    <div className={'loading-container'}>

                        <MCLoading white/>
                    </div>
                )
            }


            {props.buttonLabel} <FatChevron className={'chevron'}/>


        </NRTButton>
    )
}

ButtonWithChevron.propTypes = {
    loading: PropTypes.bool,
    buttonLabel: PropTypes.string.isRequired,
    ...NRTButton.propTypes
}

ButtonWithChevron.defaultProps = {
    loading: false
}

export default ButtonWithChevron



// WEBPACK FOOTER //
// ./src/components/_minha-central/ButtonWithChevron/index.js